module.exports = {
    'Log in': 'Connectez-vous',
    'You must be an <span>XXL</span> member': 'Vous devez être membre <span>XXL</span>',
    'You must be an XXL member': 'Vous devez être membre XXL',
    'to watch full video.': 'pour regarder la vidéo en entier.',
    'to post a comment': 'pour ajouter un commentaire.',
    'Become an XXL member': 'Devenez membre XXL',

    "Loading...": "En cours de chargement...", // videoplayer
    "%1, location: <strong>%2</strong>": "Le %1, localisation : <strong>%2</strong>",
    "Like": "J’aime", // videoplayer
    "Liked": "J’aime", // videoplayer
    "%1 views": "%1 vues", // videoplayer
    "Comments": "Commentaires", // videoplayer
    "Enter your message": "Ajouter un commentaire", // videoplayer
    "Sending...": "En cours d’envoi...",
    
    'Pending': "En attente",
    'Processed': "En cours",
    'Rejected': "Refusée",
    'Published': "Publié",
    'Approved': "Approuvé",
};


// WEBPACK FOOTER //
// ./src/l10n-messages/fr/amateur_film.js